module.exports = __webpack_public_path__ + "img/logo.eb3f6f0f.svg";